@if (changes.length === 1) {
  <div class="d-flex align-items-start g-2 option-date-changes" data-id="option-date-changes">
    <img src="assets/icons/calendar_today_blue.svg" alt="calendar" width="12" height="14" />
    <div class="option-date-changes-text text-lightblue-800">
      <p class="d-inline semi-bold">Date change</p>
      &nbsp;
      <p class="d-inline">· {{ changes[0].routeLabel }} · {{ changes[0].copy }}</p>
    </div>
  </div>
} @else if (changes.length > 1) {
  <div class="d-flex flex-column g-1 option-date-changes" data-id="option-date-changes">
    <div class="d-flex align-items-center g-2">
      <img src="assets/icons/calendar_today_blue.svg" alt="calendar" width="12" height="14" />
      <p class="semi-bold text-lightblue-800">Date changes</p>
    </div>
    @for (change of changes; track change.routeLabel + change.copy) {
      <p class="text-lightblue-800 pl-5 option-date-changes-item">
        {{ change.routeLabel }} · {{ change.copy }}
      </p>
    }
  </div>
}
